<template>
  <div id="page-plants-list">
    <div v-if="showHeaders" class="vx-row mb-2">
      <div class="vx-col w-full inline">
        <div class="inline-block">
          <span>
            <b>Batch Name: &nbsp;</b> <span>{{ batch && batch.batch_name }}</span>
          </span>
          <br />
          <span>
            <b>Batch Number: &nbsp;</b> <span>{{ batch && batch.batch_number }}</span>
          </span>
        </div>
        <div
          v-if="checkPermissionByIds([permissions.BATCH_PLANT_ADD])"
          @click="$router.push(`/batches/${$route.params.id}/plants/create`)"
          class="btn-add-new content p-2 rounded-lg cursor-pointer items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary float-right"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Add Batch Plant</span>
        </div>
      </div>
    </div>
    <hr v-if="showHeaders" />
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <vs-table
          :id="`${list}-table-loading`"
          :ref="`${list}-table-loading`"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="500px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="FilteredCount"
          pagination
          :max-items="length"
          search
          :data="plants"
        >
          <template slot="header">
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
              <!-- ITEMS PER PAGE -->
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ FilteredCount }} (filtered from {{ total }} total entries)
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th sort-key="batch_plant.plant_name">Strain Name</vs-th>
            <vs-th sort-key="batch_plant.serialNumber">Serial Number</vs-th>
            <vs-th sort-key="batch_plant.plant_stage">Stage</vs-th>
            <vs-th sort-key="batch_plant.room_type">Room Type</vs-th>
            <vs-th sort-key="batch_plant.grow_method">Grow Method</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }" ref="tableBody">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ tr.plant_name }}
              </vs-td>
              <vs-td>
                {{ tr.serialNumber }}
              </vs-td>
              <vs-td>
                {{ getPlantStage(tr.plant_stage) }}
              </vs-td>
              <vs-td>
                {{ tr.room_type }}
              </vs-td>
              <vs-td>
                {{ tr.grow_method }}
              </vs-td>
              <vs-td :data="tr.id">
                <div
                  class="inline-flex"
                  v-if="checkPermissionByIds([permissions.BATCH_PLANT_EDIT]) || checkPermissionByIds([permissions.BATCH_PLANT_DELETE])"
                  :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }"
                >
                  <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_PLANT_EDIT])" text="Edit Plant">
                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="sendToEditPage(tr.id)" />
                  </vx-tooltip>
                  <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_PLANT_DELETE])" text="Delete Plant">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5  hover:text-danger cursor-pointer" @click="deleteRecord(tr.id)" />
                  </vx-tooltip>
                </div>
                <div v-else>-</div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { plantStages } from '@/utils/batch-options'

export default {
  name: 'BatchPlants',
  props: {
    showHeaders: {
      type: Boolean,
      default: false
    },
    list: {
      type: String
    },
    plantStages: {
      type: Array
    }
  },
  data: () => ({
    order: [],
    length: 10,
    page: 1,
    search: ''
  }),
  computed: {
    ...mapState('batch', {
      batch: 'batch',
      plants(state) {
        return state[`${this.list}-plants`]
      },
      total(state) {
        return state[`${this.list}-total`]
      },
      loading(state) {
        return state[`${this.list}-loading`]
      },
      FilteredCount(state) {
        return state[`${this.list}-FilteredCount`]
      }
    }),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),
    getPlantStage() {
      // eslint-disable-next-line init-declarations
      let s
      return (stage) => stage && (s = plantStages.find((s) => stage === s.value)) && s.label
    }
  },
  methods: {
    ...mapActions('batch', { getBatchPlants: 'getBatchPlants', deleteBatchPlantAsync: 'deleteBatchPlant' }),
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteBatchPlant(id),
        acceptText: 'Delete'
      })
    },
    deleteBatchPlant(id) {
      this.deleteBatchPlantAsync(id)
        .then(() => {
          if (this.page !== 1) {
            this.page -= 1
          }

          this.$vs.notify({
            title: 'Success',
            text: 'Batch deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      const { page, length, order, search, plantStages, list } = this
      this.getBatchPlants({
        id: this.$route.params.id,
        list,
        data: {
          page,
          limit: length,
          order,
          search,
          plantStages
        }
      })
        .then(() => {})
        .catch(() => {})
    },
    sendToEditPage(id) {
      this.$router.push(`/batches/${this.$route.params.id}/plants/${id}/edit`)
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: this.$refs[`${this.list}-table-loading`].$el,
          scale: 0.45
        })
      } else {
        this.$vs.loading.close(`#${this.list}-table-loading > .con-vs-loading`)
      }
    }
  }
}
</script>